import { useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog";
import { useQuery, useQueryClient } from "react-query";
import { getImageMenus } from "services/api/ImageManagerMenu";
import { getImageListByMenu } from "services/api/ImageList";
import ImageManagerImages from "./modules/ImageManagerImages";
import ImageManagerFolders from "./modules/ImageManagerFolders";
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

export default function DialogImageManager({ open, actionClose, setImageSelected }) {
  const queryClient = useQueryClient()
  const [selectedImageCategory, setSelectedImageCategory] = useState(null)
  const [imageList, setImagesList] = useState(null)
  const [selectedImageList, setSelectedImageList] = useState([])
  const [disableMainButtons, setDisableMainButtons] = useState(false)
  const { error, data: dataImageCategories } = useQuery('imageCategoriesList',
    getImageMenus, { refetchOnWindowFocus: false, enabled: open }
  )
  const { refetch: refetchIL, data: dataImageList } = useQuery(['imageList', selectedImageCategory],
    () => getImageListByMenu(selectedImageCategory._id), { refetchOnWindowFocus: false, enabled: false }
  )

  useEffect(() => {
    if (dataImageList !== undefined && dataImageList !== null && dataImageList !== "")
      setImagesList(dataImageList.data)
  }, [dataImageList])

  const handleReturnToImageCategory = () => {
    setSelectedImageCategory(null)
    setImagesList(null)
  }

  const handleCloseDialogImageManager = () => {
    setSelectedImageCategory(null)
    setSelectedImageList([])
    setImagesList(null)
    actionClose(false)
  }

  const handleRefresData = () => { queryClient.invalidateQueries('imageCategoriesList') }

  const handleResetActions = (action) => {
    if (action === "addImageList") refetchIL()
    if (action === "removeImageList") refetchIL()
  }

  const handleWatchAction = (action, cancel, error, success) => {
    if (cancel) return;
    if (!success) { alert(error.message) } else {
      handleRefresData(); handleResetActions(action)
    }
  }

  const handleReturnImageSelected = () => {
    setImageSelected(selectedImageList.url)
    handleCloseDialogImageManager()
  }

  const handleSelectedImageList = (image, type) => { //type: 0=one 1=multiple 2=clear
    switch (type) {
      case 0:
        selectedImageList.length > 0 && selectedImageList[0].id === image.id ?
          setSelectedImageList([]) :
          setSelectedImageList([image])
        break;
      case 1:
        const check = selectedImageList.findIndex(i => i._id === image._id)
        if (selectedImageList.length > 0 && check !== -1) {
          const temp = [...selectedImageList]
          temp.splice(check, 1)
          setSelectedImageList(temp)
        }
        if (selectedImageList.length > 0 && check === -1) {
          setSelectedImageList([...selectedImageList, image])
        }
        break;
      case 2:
        setSelectedImageList(image)
        break;
      default:
        break;
    }
  }

  if (error) return <div> Ha ocurrido un error </div>

  const Actions = () => (<>
    <Button onClick={handleCloseDialogImageManager} disabled={disableMainButtons} >Cerrar</Button>
    {selectedImageList && selectedImageList.length === 1 && <Button onClick={handleReturnImageSelected} variant="contained" disabled={disableMainButtons}>Establecer imagen</Button>}
  </>)

  return (<>
    <FlexibleWidthDialog
      maxWidth="lg"
      title={
        selectedImageCategory ? <>
          <IconButton size="medium" onClick={() => handleReturnToImageCategory()}><ArrowBackIcon /> </IconButton>
          &nbsp; Regresar a carpetas
        </> : <>Biblioteca de imágenes</>
      }
      open={open}
      actions={<Actions />}
    >
      <div className="im-main-container">
        {(dataImageCategories !== null && imageList === null) &&
          <div>
            <ImageManagerFolders
              dataImageCategories={dataImageCategories}
              selectedImageCategory={selectedImageCategory}
              setSelectedImageCategory={setSelectedImageCategory}
              imageList={imageList}
              setImageList={setImagesList}
            />
          </div>
        }
        {(selectedImageCategory !== null && imageList !== null) &&
          <div className="im-image-categories-container">
            <ImageManagerImages
              imageCategory={selectedImageCategory}
              dataImageList={imageList}
              selectedImageList={selectedImageList}
              setSelectedImageList={handleSelectedImageList}
              setDisableMainButtons={setDisableMainButtons}
              reportAction={handleWatchAction}
            />
          </div>}
      </div>
    </FlexibleWidthDialog>
  </>)
}